var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1875 2.59119V10.8428L8.5 13.1934L9.8125 10.8428V2.59119H7.1875ZM6.0625 2.4371C6.0625 2.0116 6.48223 1.66666 7 1.66666H10C10.5178 1.66666 10.9375 2.0116 10.9375 2.4371V10.8765C10.9375 10.9874 10.9084 11.097 10.8521 11.1978L9.35208 13.8842C9.01771 14.483 7.98229 14.483 7.64792 13.8842L6.14792 11.1978C6.09164 11.097 6.0625 10.9874 6.0625 10.8765V2.4371Z",
    fill: "#1C3863"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.82075C5.5 1.73565 5.58395 1.66666 5.6875 1.66666H11.3125C11.4161 1.66666 11.5 1.73565 11.5 1.82075V2.4371C11.5 2.5222 11.4161 2.59119 11.3125 2.59119H5.6875C5.58395 2.59119 5.5 2.5222 5.5 2.4371V1.82075Z",
    fill: "#1C3863"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4375 5.82702C6.4375 5.74192 6.52145 5.67294 6.625 5.67294H10.5625C10.6661 5.67294 10.75 5.74192 10.75 5.82702V6.44337C10.75 6.52847 10.6661 6.59746 10.5625 6.59746H6.625C6.52145 6.59746 6.4375 6.52847 6.4375 6.44337V5.82702Z",
    fill: "#1C3863"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 7.75312C8.875 7.62547 9.00092 7.52199 9.15625 7.52199C9.31158 7.52199 9.4375 7.62547 9.4375 7.75312V8.52355C9.4375 8.6512 9.31158 8.75468 9.15625 8.75468C9.00092 8.75468 8.875 8.6512 8.875 8.52355V7.75312Z",
    fill: "#1C3863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.1982d9dbf2221bacfc8bf7271dd60e97.svg";
export { ForwardRef as ReactComponent };